<template>
  <span class="pl-logo" :class="`pl-logo--${size}`">
    <PlMark :width="markWidth" class="pl-logo__mark" :style="{ color: markColor }" />
    <span class="pl-logo__word">PEAKSLOG</span>
  </span>
</template>

<script setup>
import { computed } from 'vue'
import PlMark from './PlMark.vue'

const props = defineProps({
  // sm = dashboard (21 px), md = landing (23 px), lg = logowanie (25 px)
  size: { type: String, default: 'sm' },
  markColor: { type: String, default: 'var(--pl-color-accent-clay)' }
})

// Szerokość znaku (proporcje 180:132): wysokość ≈ wysokość wersalików napisu
const markWidth = computed(() => ({ sm: 30, md: 32, lg: 35 }[props.size] || 30))
</script>

<style scoped>
.pl-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.pl-logo__word {
  font: var(--pl-type-wordmark);
  letter-spacing: var(--pl-type-wordmark-ls);
  color: var(--pl-color-text-primary);
}

.pl-logo--md {
  gap: 10px;
}

.pl-logo--md .pl-logo__word {
  font: var(--pl-type-landing-wordmark);
  letter-spacing: var(--pl-type-landing-wordmark-ls);
}

.pl-logo--lg {
  gap: 11px;
}

.pl-logo--lg .pl-logo__word {
  font: var(--pl-type-wordmark-large);
  letter-spacing: var(--pl-type-wordmark-large-ls);
}
</style>
